import { useEffect, useRef } from "react";
import { connect } from "react-redux";

import type { LoginResponseType } from "@/redux/auth/authTypes";
import {
  resetNotificationCount,
  setAttendence,
  setNotificationCount,
} from "@/redux/notification";
import type { RootState } from "@/redux/rootReducers";

import { initializeSocket } from "@/utils/commonFunctions";

type AppProps = {
  loginData: LoginResponseType;
  dispatchSetNotificationCount: (data: any) => void;
  dispatchResetNotificationCount: () => void;
  dispatchsetAttendence: (data: any) => void;
};

const Socket = ({
  loginData,
  dispatchSetNotificationCount,
  dispatchResetNotificationCount,
  dispatchsetAttendence,
}: AppProps) => {
  const socketRef = useRef<any>(null);

  useEffect(() => {
    if (!loginData?.user_id) return;

    if (!socketRef.current) {
      socketRef.current = initializeSocket(Number(loginData.user_id));
    }

    const socket = socketRef.current;

    socket.on("send_count", (data: any) => {
      dispatchsetAttendence({
        attendence: data?.attendence || null,
      });

      dispatchSetNotificationCount({
        count: data?.count ?? 0,
      });
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.off("send_count");
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [loginData?.user_id]);

  return null;
};

const mapStateToProps = (state: RootState) => ({
  loginData: state.auth.loginData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchSetNotificationCount: (data: any) =>
    dispatch(setNotificationCount(data)),
  dispatchResetNotificationCount: () => dispatch(resetNotificationCount()),
  dispatchsetAttendence: (data: any) => dispatch(setAttendence(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Socket);
